import * as yup from "yup";

export const OTP_LENGTH = 6;

export function createOtpSchema({ invalidError } = {}) {
  return yup
    .string()
    .matches(new RegExp(`^[0-9]{${OTP_LENGTH}}$`), invalidError);
}
